import React from 'react';
import Text from 'ui/Text';
import { FormattedMessage } from 'react-intl';

import whoWeAre from 'assets/who-we-are-bg.jpg';
import epicBanner from 'assets/epic-banner2.png';

const WhoWeAre = () => {
  return (
    <div
      id="who-we-are"
      className="row no-margin who-we-are"
      style={{ backgroundImage: `url(${whoWeAre})` }}>
      <div className="col-sm-12 col-md-7 col-lg-7 pitch">
        <Text type="sub-head" modifiers="near-black heavy title">
          <FormattedMessage id="WhoWeAre.Title" defaultMessage="Who We Are" />
          <span className="fake-border fake-border__underline" />
        </Text>
        <Text type="explanation" modifiers="near-black text-justify">
          <FormattedMessage
            id="WhoWeAre.Explanation"
            defaultMessage="Co-founded by Adwoa Agyeman and Rose Maruru in 2015, EPIC-Africa is a Senegal-based, pan-
            African organization that seeks to strengthen the ecosystem for philanthropy in Africa. EPIC-Africa is
            developing new approaches to help build a robust and resilient civil society sector. The
            organization’s creative use of data and technology offers African CSOs a unique platform to
            demonstrate transparency, reinforce legitimacy and build credibility. EPIC-Africa’s services and tools
            create opportunities for CSOs and their funders to share knowledge, build capacity and scale impact."
          />
        </Text>
        <a
          className="btn btn-primary cta__landing-page"
          href="http://www.epic-africa.org/"
          target="_blank"
          rel="noopener noreferrer">
          <Text>
            <FormattedMessage id="WhoWeAre.Visit" defaultMessage="Visit Our Site" />
          </Text>
        </a>
      </div>
    </div>
  );
};

export default WhoWeAre;



// WEBPACK FOOTER //
// ./src/components/HomePage/WhoWeAre.js